import { render, staticRenderFns } from "./awsc.vue?vue&type=template&id=65e9c0d6&scoped=true&"
import script from "./awsc.vue?vue&type=script&lang=js&"
export * from "./awsc.vue?vue&type=script&lang=js&"
import style0 from "./awsc.vue?vue&type=style&index=0&id=65e9c0d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e9c0d6",
  null
  
)

export default component.exports